<template lang="html">
  <div class="posting-box">
    <div class="posting-box-goal">
      <div class="goal-dropdown">
        <div class="form-group">
          <select class="form-control" id="exampleFormControlSelect1">
            <option>Workout in the gym</option>
            <option>Read more books</option>
            <option>Work on Proove</option>
          </select>
        </div>
      </div>
      <div class="date-dropdown">
        <div class="date-container">
          <div class="the-date">
            Today
          </div>
          <div class="the-date-dropdown">
            <button type="button" class="btn btn-default"><i class="fas fa-caret-down"></i></button>
          </div>
        </div>
      </div>
      <div class="details-dropdown">
        <button type="button" class="btn btn-block btn-default"><i class="fas fa-tasks" data-toggle="tooltip" data-placement="top" title="Add Details"></i></button>
      </div>
      <div class="completed-dropdown">
        <button type="button" class="btn btn-block btn-default goal-completed" data-toggle="tooltip" data-placement="top" title="Mark Goal As Complete"><i class="fas fa-check"></i></button>
      </div>
    </div>
    <div class="posting-box-copy">
      <div class="headshot">
        <img src="http://www.placehold.it/40x40" class="rounded-circle" alt="">
      </div>
      <div class="posting-box-textarea">
        <textarea-autosize rows="1" id="comment-box" class="form-control" placeholder="Write something" :min-height="100" :max-height="350"></textarea-autosize>
      </div>
    </div>
    <div class="posting-box-options">
      <div class="options">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-sm btn-secondary" data-toggle="tooltip" data-placement="top" title="Add Photos">
            <i class="fas fa-images"></i>
          </button>
          <button type="button" class="btn btn-sm btn-secondary" data-toggle="tooltip" data-placement="top" title="Add Videos">
            <i class="fas fa-video"></i>
          </button>
          <button type="button" class="btn btn-sm btn-secondary" data-toggle="tooltip" data-placement="top" title="Tag Location">
            <i class="fas fa-map-marker-alt"></i>
          </button>
          <button type="button" class="btn btn-sm btn-secondary content-added" data-toggle="tooltip" data-placement="top" title="Molly Johnson, Anna Keegan, Ryan Hanson">
            <i class="fas fa-user-plus"></i>
          </button>
        </div>
      </div>
      <div class="proove-it-button">
        <button type="button" class="btn btn-sm btn-block btn-primary">Proove It</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueTextareaAutosize from 'vue-textarea-autosize'

export default {
  name: 'PostBox',
  created() {
    Vue.use(VueTextareaAutosize)
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }
}
</script>

<style scoped>
.posting-box {
  margin-bottom: 30px;
  border-radius: 5px;
  border: 2px solid #c9c9c9;
}
.posting-box-goal {
  display: flex;
  border-radius: 5px 5px 0 0;
  background: #efefef;
  border-bottom: 1px solid #c9c9c9;
}
.posting-box-goal .goal-dropdown {
  flex: 4;
  border-right: 1px solid #c9c9c9;
  margin-right: 5px;
  padding-right: 5px;
  padding-left: 5px;
}
.posting-box-goal .goal-dropdown .form-group {
  margin: 0;
}
.posting-box-goal .goal-dropdown select {
  font-size: 12px;
  background: none;
  border: none;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  color: #000;
  font-weight: bold;
}
.posting-box-goal .date-dropdown {
  flex: 3;
  border-right: 1px solid #c9c9c9;
}
.posting-box-goal .date-dropdown .date-container {
  display: flex;
  margin-left: 5px;
}
.posting-box-goal .date-dropdown .date-container .the-date {
  flex: 3;
  text-align: left;
  overflow: hidden;
  font-size: 12px;
  padding-top: 10px;
  color: #000;
}
.posting-box-goal .date-dropdown .date-container .the-date-dropdown {
  flex: 1;
  text-align: right;
}
.posting-box-goal .date-dropdown .date-container .the-date-dropdown button {
  background: none;
  font-size: 14px;
}
.posting-box-goal .details-dropdown {
  flex: 1;
  border-right: 1px solid #c9c9c9;
}
.posting-box-goal .details-dropdown button {
  background: none;
  font-size: 14px;
}
.posting-box-goal .completed-dropdown {
  flex: 1;
}
.posting-box-goal .completed-dropdown button {
  background: none;
  font-size: 14px;
}
.posting-box-goal .completed-dropdown button.goal-completed {
  color: #007bff !important;
}
.posting-box-copy {
  display: flex;
  margin: 10px 0;
}
.posting-box-copy .headshot {
  flex: 1;
  text-align: right;
}
.posting-box-copy .posting-box-textarea {
  flex: 7;
}
.posting-box-copy .posting-box-textarea textarea {
  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none; /*remove the resize handle on the bottom right*/
}
.posting-box-options {
  display: flex;
  background: #efefef;
  border-radius: 0 0 5px 5px;
  border-top: 1px dotted #c9c9c9;
}
.posting-box-options .options {
  flex: 7;
  padding-left: 5px;
}
.posting-box-options .options button {
  background: none;
  border: none;
  color: #6c757d;
  font-size: 13px;
  margin-top: 10px;
  margin-right: 0px;
  padding: 0 7px;
}
.posting-box-options .options button:active {
  background: none;
  color: #000;
}
.posting-box-options .options button.content-added {
  color: #007bff !important;
}
.posting-box-options .proove-it-button {
  flex: 2;
}
.posting-box-options .proove-it-button button {
  border-radius: 0 0 5px 0;
  padding: 8px 5px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/utility/PostBox.vue